<bento-alert [items]="alerts">
</bento-alert>
<div class="ng-bento" [bentoBusyLoader]="showBusyloader">
	<bento-contextual-header class="contextual-header" [items]="headerItems" (backButtonClick)="back()" data-qe-id="migration-client-registrations-back-button"></bento-contextual-header>
	<p class="text-left" *ngIf="tab==='notSent'" [innerHTML]="'onvio.setup.migrations.status.completed.clientCenterRegistrations.notSent.subtext' | translate"></p>
	<p class="text-left" *ngIf="tab==='pending'" [innerHTML]="'onvio.setup.migrations.status.completed.clientCenterRegistrations.pending.subtext' | translate"></p>
	<div class="tabs">
		<p class="text-left">
			<span class="not-sent"
				  data-qe-id="migration-client-registration-not-sent-tab"
				  (click)="navigateTab('notSent')" [ngClass]="{'active':tab==='notSent'}">
				{{'onvio.setup.migrations.status.completed.clientCenterRegistrations.notSent' | translate}}
			</span>
			<span class="badge badge-primary">{{notSentCount}}</span>
			<span class="pending"
				  data-qe-id="migration-client-registrations-pending-tab"
				  (click)="navigateTab('pending')" [ngClass]="{'active':tab==='pending'}">
				{{'onvio.setup.migrations.status.completed.clientCenterRegistrations.pending' | translate}}
			</span>
			<span class="badge badge-primary">{{pendingCount}}</span>
		</p>
	</div>
	<bento-toolbar data-qe-id="migration-client-registrations-toolbar" class="bento-toolbar" [items]="toolbarData" #toolbar></bento-toolbar>
	<wj-flex-grid
		#flexGrid
		id="flexGrid"
		control="flexGrid"
		[isReadOnly]="true"
		[itemsSource]="contacts"
		[showSort]="true"
		class="bento-flex-grid">

		<ng-template wjFlexGridCellTemplate [cellType]="'TopLeft'" let-col="col">
			<div>
			  <bento-checkbox
				(change)="onHeaderCheckboxChange()"
				[(ngModel)]="headerSelected"
				ng-class="{'bento-icon-checkmark':headerCheckBoxMode === CHECKBOX_SELECTED,'bento-icon-minus-plain':headerCheckBoxMode === CHECKBOX_INDETERMINATE}"
			  ></bento-checkbox>
			</div>
		</ng-template>

		<ng-template wjFlexGridCellTemplate [cellType]="'RowHeader'" let-col="col" let-row="row" let-item="item">
			<div *ngIf="col.index === 0">
			  <bento-checkbox
				[ngModel]="item.selected"
				data-qe-id="migration-client-registrations-grid-row-checkbox"
				(change)="item.disabled||(item.selected = !item.selected);onCheckBoxChange(item);"
			  ></bento-checkbox>
			</div>
		</ng-template>
		<wj-flex-grid-column
			*ngFor="let col of columnDefinitions"
			[binding]="col.binding"
			[header]="col.header"
			[visible]="col.visible"
			[width]="col.width">
		</wj-flex-grid-column>
		<wj-flex-grid-column
			*ngIf="tab==='pending'"
			[binding]="'registrationSent'"
			[header]="'Registration sent'"
			[width]="'*'">
		</wj-flex-grid-column>
	</wj-flex-grid>
</div>
